import DefaultLayout from "@/layouts/DefaultLayout";
import KSalesOrderErrorsTable from "kinnect-front/Sales/SalesOrders/KSalesOrderErrorsTable";
import OutboundFreightDeleteDialog from "kinnect-front/Warehouse/OutboundFreight/OutboundFreightDeleteDialog";
import OutboundFreightForm from "kinnect-front/Warehouse/OutboundFreight/OutboundFreightForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { OutboundFreight } from "kinnect-models";
import { VCard } from "vuetify/lib";

export default {
	name: "OutboundFreightPage",

	metaInfo() {
		return { title: `Warehouse - Outbound Freight - ${this.editing ? "Edit" : "Add"}` };
	},

	props: { idOutboundFreight: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "outbound_freight",
		deleteDialogOpen: false,
		outboundFreight: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idOutboundFreight );
		},

		genDeleteDialog() {
			if ( this.editing && this.outboundFreight && this.canDelete ) {
				return <OutboundFreightDeleteDialog
					item={this.outboundFreight}
					onConfirm={() => this.outboundFreight.delete()}
					redirect={[ "back", { name: "outboundFreightList" } ]}
					vModel={this.deleteDialogOpen}
				></OutboundFreightDeleteDialog>;
			}
		},

		toolbarActions() {
			const actions = [];

			if ( this.editing && this.canDelete ) {
				actions.push( {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this outbound freight"
				} );
			}

			if ( this.editing && this.canEdit ) {
				actions.push( {
					icon: "add_circle",
					text: "Add Error",
					to: {
						name: "outboundFreightErrorAdd",
						params: { idOutboundFreight: this.idOutboundFreight }
					},
					tooltip: "Add an error to this outbound freight"
				} );
			}

			return actions;
		}
	},

	methods: {
		async fetchOutboundFreight() {
			if ( this.editing ) {
				this.outboundFreight = await OutboundFreight
				.include( [
					"address",
					"sales-orders.errors.error-types",
					"sales-orders.errors.sales-orders"
				] )
				.findPageModel( this.idOutboundFreight );
			}
		},

		async fetch() {
			await this.fetchOutboundFreight();
		}
	},

	render() {
		return <DefaultLayout maxWidth="700px">
			<OutboundFreightForm
				loading={this.$wait.is( "find outbound freight" )}
				outboundFreight={this.outboundFreight}
				readonly={this.editing ? !this.canEdit : false}
			></OutboundFreightForm>

			{this.editing && <VCard class="mt-4">
				<KSalesOrderErrorsTable
					items={this.outboundFreight ? this.outboundFreight.salesOrderErrors : []}
					loading={this.$wait.is( "find outbound freight" )}
				>
					<template slot="title">Errors</template>
				</KSalesOrderErrorsTable>
			</VCard>}

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
